@if (belt()) {
  <div class="belt-info">
    @if (length()) {
      <vectronic-details-item header="Length">
        <ng-container>{{ length() }}</ng-container>
      </vectronic-details-item>
    }
    @if (belt().shape) {
      <vectronic-details-item header="Shape">
        <ng-container>{{ belt().shape }}</ng-container>
      </vectronic-details-item>
    }
    @if (belt().color) {
      <vectronic-details-item header="Color">
        <ng-container>{{ belt().color }}</ng-container>
      </vectronic-details-item>
    }
    @if (belt().width) {
      <vectronic-details-item header="Width">
        <ng-container>{{ belt().width }} mm</ng-container>
      </vectronic-details-item>
    }
    @if (belt().thickness) {
      <vectronic-details-item header="Thickness">
        <ng-container>{{ belt().thickness }}</ng-container>
      </vectronic-details-item>
    }
    @if (belt().edge) {
      <vectronic-details-item header="Edge">
        <ng-container>{{ belt().edge }}</ng-container>
      </vectronic-details-item>
    }
    @if (belt().cottonLayer > 0) {
      <vectronic-details-item header="Cotton layer">
        <ng-container>{{ belt().cottonLayer }}</ng-container>
      </vectronic-details-item>
    }
    @if (belt().paintedLabel) {
      <vectronic-details-item header="Painted label">
        <ng-container>{{ belt().paintedLabel.substring(0, 3) }}</ng-container>
      </vectronic-details-item>
    }
    @if (belt().protective) {
      <vectronic-details-item header="Protective layer">
        <ng-container>{{ belt().protective }}</ng-container>
      </vectronic-details-item>
    }
    @if (belt().reflectiveStripe) {
      <vectronic-details-item header="Reflective stripe">
        <ng-container>{{ belt().reflectiveStripe }}</ng-container>
      </vectronic-details-item>
    }
    @if (belt().punchingScrewSize || belt().punchingSpace) {
      <vectronic-details-item header="Punching">
        <ng-container>{{ belt().punchingScrewSize + ' - ' + belt().punchingSpace }}</ng-container>
      </vectronic-details-item>
    }
    @if (belt().labelPlate) {
      <vectronic-details-item header="Label plate">
        <div>{{ belt().labelPlate }}</div>
      </vectronic-details-item>
    }
    @if (belt().growingBeltType) {
      <vectronic-details-item header="Growing Belt Type">
        <div>{{ belt().growingBeltType }}</div>
      </vectronic-details-item>
    }
    @if (belt().elasticBeltType) {
      <vectronic-details-item header="Elastic Belt Type">
        <div>{{ belt().elasticBeltType }}</div>
      </vectronic-details-item>
    }
  </div>
}
